import React, { useState, useEffect, useContext } from 'react';
import { Button, Modal, Box, Typography, Card, IconButton, CardActions, Chip, List, ListItem } from '@mui/material';
import axios from 'axios';
import { UserContext } from '../UserContext';
import CropRotateIcon from '@mui/icons-material/CropRotate';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import LabeledTextField from './LabeledTextField';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './AddProduct.css';
import DrawerComponent from './common/DrawerComponent';
import {
  Close as CloseIcon,
  Description as DescriptionIcon,
  OpenInNew as OpenInNewIcon
} from '@mui/icons-material';
// Add these to your existing imports
import { Paper, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { ChevronRight as ChevronRightIcon } from '@mui/icons-material';

const ProductManagement = () => {
  const [open, setOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sidebars, setSidebars] = useState([]);
  const [roleId, setRoleId] = useState(null)
  console.log(roleId,"roleId");
  const [openModal, setOpenModal] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewContent, setPreviewContent] = useState(null);
  const [product, setProduct] = useState({
    id: null,
    product_name: '',
    product_type: '',
    product_description: '',
    img: '',
    color: '',
     documents: []
  });
  const [productToDelete, setProductToDelete] = useState(null);
  const { user_id, role } = useContext(UserContext);
  const [currentDate, setCurrentDate] = useState(getFormattedDate());
  const [documents, setDocuments] = useState([{ file: null, name: '' }]);
  console.log("previewContent",previewContent)

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get('api/products/');
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }

  };

  useEffect(() => {
    async function fetchRoleId() {
      if (!role) return;
      try {
        const response = await axios.get(
          `/api/get-role-id/`,
          { params: { role_name: role } }
        );
        setRoleId(response.data.role_id);
      } catch (error) {
        console.error("Error fetching role id:", error);
        toast.error("Failed to fetch role id");
      }
    }
    fetchRoleId();
  }, [role]);


  useEffect(() => {
    async function fetchSidebarPermissions() {
      if (!roleId) return;
      setIsLoading(true);
      try {
        const response = await axios.get(
          `/api/sidebars/role/${roleId}/`
        );
        setSidebars(Array.isArray(response.data) ? response.data : []);
      } catch (error) {
        console.error("Error fetching sidebar permissions:", error);
        toast.error("Failed to fetch sidebar permissions");
      } finally {
        setIsLoading(false);
      }
    }
    fetchSidebarPermissions();
  }, [roleId]);

  console.log(sidebars, "11111111111");

    const addProductSidebar = sidebars.find(
    (item) => item.action_link === "/AddProduct"
  );

  const rolePermissions = addProductSidebar?.roles.find(
    (role) => role.role_id === roleId
  )?.permissions;

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setProduct({
      id: null,
      product_name: '',
      product_type: '',
      product_description: '',
      color: '',
      img: '',
    });
    setOpen(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduct((prevProduct) => ({
      ...prevProduct,
      [name]: value,
    }));
  };


const handleDocumentChange = (e) => {
  const files = Array.from(e.target.files);
  setDocuments(files.map((file) => ({ file })));
}

    const handleAddDocument = () => {
        setDocuments([...documents, { file: null, id: null }]);
    };

// Update your handleSubmit function
const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const formData = new FormData();
    formData.append('product_name', product.product_name);
    formData.append('product_type', product.product_type);
    formData.append('product_description', product.product_description);
    formData.append('color', product.color);
    
    // Handle image for both create and update
    if (product.img && typeof product.img !== 'string') {
      formData.append('img', product.img);
    }
    
    // Handle document for both create and update
    documents.forEach((document, index) => {
                if (document.file) {
                    formData.append(`documents[${index}]document`, document.file);
                } else if (document.id) {
                    formData.append(`documents[${index}]id`, document.id);
                }
            });
    
    if (product.id) {
      await axios.put(`api/products/${product.id}/?updated_by=${user_id}`, formData);
      toast.success('Product Successfully Updated.');
    } else {
      await axios.post(`api/products/?created_by=${user_id}`, formData);
      toast.success("Product Successfully Created.");
    }
    
    fetchProducts();
    handleClose();
  } catch (error) {
    console.error('Error saving product:', error);
    toast.error('Error Saving Product');
  }
};

  const handleEdit = (product) => {
    setProduct(product);
    handleOpen();
  };

  const handleDelete = (id) => {
    setProductToDelete(id);
    setConfirmOpen(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(`api/products/${productToDelete}/?deleted_by=${user_id}`);
      fetchProducts();
      toast.success('Product Deleted successfully');
    } catch (error) {
      console.error('Error deleting product:', error);
      toast.error('Error deleting Product');
    } finally {
      setProductToDelete(null);
      setConfirmOpen(false);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setProduct((prev) => ({
      ...prev,
      img: file,
    }));
  };

  function getFormattedDate() {
    const now = new Date();
    const day = now.toLocaleString('en-US', { weekday: 'short' });
    const month = now.toLocaleString('en-US', { month: 'short' });
    const date = now.toLocaleString('en-US', { day: '2-digit' });
    const year = now.getFullYear();
    const time = now.toLocaleString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
    return `${day}, ${month} ${date}, ${year} ${time}`;
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentDate(getFormattedDate());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  console.log(role, "role");

const handleDocumentsPreview = (prod) => {
  setSelectedProduct(prod);
  setSelectedDocuments(prod.documents);
  setOpenModal(true);
};

const handleCloseModal = () => {
  setOpenModal(false);
};
const getFullUrl = (url) => url;
const officeExts = ["doc", "docx", "ppt", "pptx", "xls", "xlsx"];

const handleClosePreview = () => {
  setPreviewModalVisible(false);
  setPreviewContent(null);
};

const handlePreview = async (item) => {
  if (!item.document) {
    toast.error("Invalid file selected for preview");
    return;
  }
  
  // Example item.document: "/media/Product_documents/Dummy-Excel.xlsx"
  const modifiedFilePath = item.document;
  const fileName = item.document.split("/").pop();
  const ext = fileName.split(".").pop().toLowerCase();
  const previewUrl = getFullUrl(modifiedFilePath); 

  if (!previewUrl) {
    toast.error("No file link available for preview");
    return;
  }

  if (item.type === "folder") {
    toast.error("Previewing folders is not supported.");
    return;
  }

  // --- CORRECTED HELPER FUNCTION ---
  const getPdfPreviewUrl = (originalUrl) => {
    // Log the original URL for debugging
    console.log("Original URL for Office doc:", originalUrl);
    
    // IMPORTANT: Remove the '/media/' prefix from the path.
    // The backend only needs the path relative to the media root.
    const relativePath = originalUrl.replace(/^\/media\//, "");
    
    // Log the path being sent to the backend
    console.log("Path being sent to backend:", relativePath);
    
    return `/api/preview-batch-pdf?file=${encodeURIComponent(relativePath)}`;
  };

  try {
    if (officeExts.includes(ext)) {
      const previewLink = getPdfPreviewUrl(previewUrl);
      console.log("Final Office document preview link:", previewLink);
      
      setPreviewContent(
        <iframe
          src={`${previewLink}#toolbar=0&navpanes=0&scrollbar=0`}
          style={{ width: "100%", height: "80vh", border: "none" }}
          title="File Preview"
        />
      );
    } else if (["pdf", "txt", "html", "csv"].includes(ext)) {
      setPreviewContent(
        <iframe
          src={`/api${previewUrl}#toolbar=0&navpanes=0&scrollbar=0&zoom=page-width`}
          style={{
            width: "100%",
            height: "80vh",
            border: "none",
            display: "block",
          }}
          title="File Preview"
        />
      );
    } else if (["jpg", "jpeg", "png"].includes(ext)) {
      setPreviewContent(
        <div style={{ textAlign: "center" }}>
          <img
            src={`/api${previewUrl}`}
            alt="Preview"
            style={{
              maxWidth: "100%",
              maxHeight: "80vh",
              objectFit: "contain",
              borderRadius: "4px",
            }}
          />
        </div>
      );
    } else {
      window.open(`/api${previewUrl}`, "_blank", "noopener,noreferrer");
      return;
    }

    setPreviewModalVisible(true);
  } catch (error) {
    toast.error("Preview failed");
    console.error("Preview error:", error);
  }
};
  return (
    <Box className="page-container">
      <ToastContainer />
      <div className="header-container">
        <Box className="header-icon-container">
          <CropRotateIcon style={{ color: '#fb7102', fontSize: '28px' }} />
          <span className="Title">Products</span>
        </Box>
        <span className="date-display">{currentDate}</span>
      </div>

      <Box className="content-container">
        <Box className="right-column">

          <Box className="button-container" >

            <button className="button_style" onClick={() => {
              if (rolePermissions?.is_add) {
                handleOpen();
              } else {
                toast.error("You don't have permission to add product.");
              }
            }}
            >
              <AddIcon style={{ verticalAlign: 'middle', marginRight: 6, fontSize: 25 }} />
              Add Product
            </button>

          </Box>


          <Box className="card-grid">
 {products.map((prod) => (
      <Card
        key={prod.id}
        className="card"
        style={{ background: prod.color || '#f5f5f5' }}
      >
        <img
          src={
            prod.img.startsWith('/media')
              ? `${process.env.REACT_APP_BACKEND_URL || 'api'}${prod.img}`
              : prod.img
          }
          alt={prod.product_name}
        />
        <p className="service_name">{prod.product_name}</p>

        <CardActions className="card-actions">
          {/* --- DOCUMENTS PREVIEW ICON --- */}
          {prod.documents && prod.documents.length > 0 && (
            <IconButton
              aria-label="preview documents"
              size="small"
              onClick={() => handleDocumentsPreview(prod)}
              title="Preview Documents" 
            >
              <DescriptionIcon fontSize="small" style={{ color: '#1976d2' }} />
            </IconButton>
          )}

          <IconButton
            aria-label="edit"
            size="small"
            onClick={() => {
              if (rolePermissions?.is_update) {
                handleEdit(prod);
              } else {
                toast.error("You don't have permission to Edit product.");
              }
            }}
          >
            <BorderColorIcon fontSize="small" style={{ color: '#5569a6' }} />
          </IconButton>

          <IconButton
            aria-label="delete"
            size="small"
            onClick={() => {
              if (rolePermissions?.is_delete) {
                handleDelete(prod.id);
              } else {
                toast.error("You don't have permission to Delete product.");
              }
            }}
          >
            <DeleteIcon fontSize="small" style={{ color: '#C53B31' }} />
          </IconButton>
        </CardActions>
      </Card>
    ))}
</Box>
        </Box>
      </Box>

      <DrawerComponent
  open={open}
  onClose={handleClose}
  title={product.id ? 'Edit Product' : 'Add New Product'}
>
  <form onSubmit={handleSubmit} className="drawer-form">
    <label htmlFor="custom-file-input" className="file-upload-label">
      {(product.id && product.img && typeof product.img === 'string') ? (
        <Card className="card" style={{ background: product.color || '#f5f5f5' }}>
          <img
            src={
              product.img.startsWith('/media')
                ? `${process.env.REACT_APP_BACKEND_URL || 'api'}${product.img}`
                : product.img
            }
            alt={product.product_name}
          />
          <Typography variant="body2">{product.img.name || ''}</Typography>
        </Card>
      ) : (
        <Box className="file-upload-container">
          <input
            id="custom-file-input"
            type="file"
            accept=".jpg,.jpeg,.png"
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
          <img src="upload_file.png" alt="Upload" />
          <Typography variant="body2">
            {product.img && typeof product.img !== 'string' 
              ? `Selected image: ${product.img.name}` 
              : 'No image chosen'
            }
          </Typography>
        </Box>
      )}
    </label>

    {/* Document Upload Field */}
    

    <LabeledTextField
      fullWidth
      label="Product Name"
      variant="outlined"
      margin="normal"
      name="product_name"
      value={product.product_name}
      onChange={handleChange}
      required
    />
    
    <LabeledTextField
      fullWidth
      label="Product Type"
      variant="outlined"
      margin="normal"
      name="product_type"
      value={product.product_type}
      onChange={handleChange}
      required
    />
    
    <LabeledTextField
      fullWidth
      label="Product Description"
      variant="outlined"
      margin="normal"
      name="product_description"
      value={product.product_description}
      onChange={handleChange}
      required
    />
    
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent:"space-between", gap: 2, mb: 2,mt: 2 }}>

<Box>
  <label htmlFor="document-file-input" className="file-upload-label" style={{ width: '150px' }}>
    <input
      id="document-file-input"
      type="file"
      multiple
      accept=".pdf,.doc,.docx,.txt"
      onChange={handleDocumentChange}
      style={{ display: 'none' }}
    />
    <Button 
      variant="contained" 
      component="span" 
      className="file-uplo-btn upload-button"
      startIcon={
        <img 
          src="upload_file.png" 
          alt="Upload Document" 
          style={{ width: '20px', height: '20px' }} 
        />
      }
    >
      Upload Documents
    </Button>
  </label>

  </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent:"space-between" }}>
      <input
        id="color-picker"
        type="color"
        name="color"
        value={product.color}
        onChange={(e) => setProduct((prev) => ({ ...prev, color: e.target.value }))}
        className="color-picker"
        required
      />
      <Typography component="label" htmlFor="color-picker" className="color-picker-label">
        Pick a Light Color
      </Typography>
</Box>
  <Box>
    <Button type="submit" variant="contained" className="submit-button">
      {product.id ? 'Update' : 'Submit'}
    </Button>
  </Box>
</Box>

{documents?.length > 0 && documents[0].file !==null && (
  <Box sx={{ mt: 2 }}>
    <Typography variant="body1">Selected Documents:</Typography>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {documents?.map((document, index) => (
        <Chip
          key={index}
          label={document?.name || document?.file?.name}
          onDelete={() => {
            const newDocuments = documents.filter((doc, i) => i !== index);
            setDocuments(newDocuments);
          }}
        />
      ))}
    </Box>
  </Box>
)}

{product?.documents && product?.documents.length > 0 && (
  <Box sx={{ mt: 2 }}>
    <Typography variant="body1">Uploaded Documents:</Typography>
    {product?.documents.map((document, index) => (
      <Box key={index} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="body2">
          {document.document.split('/').pop()}
        </Typography>
        <Button
          variant="contained"
          size="small"
          onClick={() => handlePreview(document)}  // Changed this line
        >
          Preview
        </Button>
      </Box>
    ))}
  </Box>
)}

  </form>
</DrawerComponent>

      <Modal open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <Box className="confirm-modal">
          <Typography variant="h6" component="h2">
            Are you sure you want to delete this product? If yes, all related enquiries will also be
            deleted automatically.
          </Typography>
          <Box className="modal-actions">
            <Button onClick={confirmDelete} className="modal-button">
              Yes
            </Button>
            <Button onClick={() => setConfirmOpen(false)} className="modal-button">
              No
            </Button>
          </Box>
        </Box>
      </Modal>


<Modal open={openModal} onClose={handleCloseModal}>
  <Box sx={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '70%', md: '50%' },
    maxHeight: '80vh',
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    overflow: 'hidden'
  }}>
    {/* Header */}
    <Box sx={{
      bgcolor: '#F08B51',
      color: 'white',
      p: 2,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }}>
    <Typography
      variant="h6"
      component="h2"
      style={{ color: 'white' }}
    >
      Documents for {selectedProduct.product_name}
    </Typography>
      <IconButton onClick={handleCloseModal} sx={{ color: 'white' }}>
        <CloseIcon />
      </IconButton>
    </Box>

    {/* Content */}
    <Box sx={{ p: 3, maxHeight: '60vh', overflow: 'auto' }}>
      {selectedDocuments.length > 0 ? (
<List sx={{ p: 0 }}>
  {selectedDocuments.map((document) => (
    <Paper key={document.id} sx={{ mb: 1, overflow: 'hidden' }}>
      <ListItemButton
        onClick={() => handlePreview(document)}
        sx={{
          '&:hover': {
            bgcolor: 'rgba(0, 0, 0, 0.04)'
          },
          py: 1.5
        }}
      >
        <ListItemIcon>
          <DescriptionIcon color="primary" />
        </ListItemIcon>
        <ListItemText
          primary={document.document.split('/').pop()}
          primaryTypographyProps={{
            fontWeight: 500,
            noWrap: true
          }}
        />
        <ChevronRightIcon color="action" />
      </ListItemButton>
    </Paper>
  ))}
</List>
      ) : (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography color="text.secondary">
            No documents available
          </Typography>
        </Box>
      )}
    </Box>

    {/* Footer */}
    <Box sx={{
      bgcolor: 'grey.50',
      p: 2,
      borderTop: '1px solid',
      borderColor: 'divider'
    }}>
      <Typography variant="caption" color="text.secondary">
        Click on any document to view
      </Typography>
    </Box>
  </Box>
</Modal>

<Modal open={previewModalVisible} onClose={handleClosePreview}>
  <Box sx={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '90%',
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    overflow: 'hidden'
  }}>
    <Box sx={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      p: 2,
      borderBottom: '1px solid #eee'
    }}>
      <Typography variant="h6">File Preview</Typography>
      <IconButton onClick={handleClosePreview}>
        <CloseIcon />
      </IconButton>
    </Box>
    <Box sx={{ height: 'calc(100% - 64px)', overflow: 'hidden' }}>
      {previewContent}
    </Box>
  </Box>
</Modal>
    </Box>
  );
};

export default ProductManagement;




// import React, { useState, useEffect, useContext } from 'react';
// import { Button, Modal, Box, Typography, Card, IconButton, CardActions, Chip, List, ListItem } from '@mui/material';
// import axios from 'axios';
// import { UserContext } from '../UserContext';
// import CropRotateIcon from '@mui/icons-material/CropRotate';
// import BorderColorIcon from '@mui/icons-material/BorderColor';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
// import LabeledTextField from './LabeledTextField';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import './AddProduct.css';
// import DrawerComponent from './common/DrawerComponent';
// import {
//   Close as CloseIcon,
//   Description as DescriptionIcon,
//   OpenInNew as OpenInNewIcon
// } from '@mui/icons-material';
// // Add these to your existing imports
// import { Paper, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
// import { ChevronRight as ChevronRightIcon } from '@mui/icons-material';

// const ProductManagement = () => {
//   const [open, setOpen] = useState(false);
//   const [confirmOpen, setConfirmOpen] = useState(false);
//   const [products, setProducts] = useState([]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [sidebars, setSidebars] = useState([]);
//   const [roleId, setRoleId] = useState(null)
//   console.log(roleId,"roleId");
//   const [openModal, setOpenModal] = useState(false);
// const [selectedDocuments, setSelectedDocuments] = useState([]);
// const [selectedProduct, setSelectedProduct] = useState({});
// const [previewModalVisible, setPreviewModalVisible] = useState(false);
// const [previewContent, setPreviewContent] = useState(null);
//   const [product, setProduct] = useState({
//     id: null,
//     product_name: '',
//     product_type: '',
//     product_description: '',
//     img: '',
//     color: '',
//      documents: []
//   });
//   const [productToDelete, setProductToDelete] = useState(null);
//   const { user_id, role } = useContext(UserContext);
//   const [currentDate, setCurrentDate] = useState(getFormattedDate());
//   const [documents, setDocuments] = useState([{ file: null, name: '' }]);
//   console.log("previewContent",previewContent)

//   useEffect(() => {
//     fetchProducts();
//   }, []);

//   const fetchProducts = async () => {
//     try {
//       const response = await axios.get('api/products/');
//       setProducts(response.data);
//     } catch (error) {
//       console.error('Error fetching products:', error);
//     }

//   };

//   useEffect(() => {
//     async function fetchRoleId() {
//       if (!role) return;
//       try {
//         const response = await axios.get(
//           `/api/get-role-id/`,
//           { params: { role_name: role } }
//         );
//         setRoleId(response.data.role_id);
//       } catch (error) {
//         console.error("Error fetching role id:", error);
//         toast.error("Failed to fetch role id");
//       }
//     }
//     fetchRoleId();
//   }, [role]);


//   useEffect(() => {
//     async function fetchSidebarPermissions() {
//       if (!roleId) return;
//       setIsLoading(true);
//       try {
//         const response = await axios.get(
//           `/api/sidebars/role/${roleId}/`
//         );
//         setSidebars(Array.isArray(response.data) ? response.data : []);
//       } catch (error) {
//         console.error("Error fetching sidebar permissions:", error);
//         toast.error("Failed to fetch sidebar permissions");
//       } finally {
//         setIsLoading(false);
//       }
//     }
//     fetchSidebarPermissions();
//   }, [roleId]);

//   console.log(sidebars, "11111111111");

//     const addProductSidebar = sidebars.find(
//     (item) => item.action_link === "/AddProduct"
//   );

//   const rolePermissions = addProductSidebar?.roles.find(
//     (role) => role.role_id === roleId
//   )?.permissions;

//   const handleOpen = () => setOpen(true);
//   const handleClose = () => {
//     setProduct({
//       id: null,
//       product_name: '',
//       product_type: '',
//       product_description: '',
//       color: '',
//       img: '',
//     });
//     setOpen(false);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setProduct((prevProduct) => ({
//       ...prevProduct,
//       [name]: value,
//     }));
//   };

// const getFullUrl = (url) => url;
// const officeExts = ["doc", "docx", "ppt", "pptx", "xls", "xlsx"];
// const handleClosePreview = () => {
//   setPreviewModalVisible(false);
//   setPreviewContent(null);
// };

// const handlePreview = async (document) => {
//   if (!document.document) {
//     toast.error("Invalid file selected for preview");
//     return;
//   }

//   const filePath = document.document; // e.g., "/media/Product_documents/file.pdf"
//   console.log("document", document);
  
//   const fileName = filePath.split("/").pop();
//   const ext = fileName.split(".").pop().toLowerCase();
  
//   if (document.type === "folder") {
//     toast.error("Previewing folders is not supported.");
//     return;
//   }

//   // Helper to construct the API endpoint URL
// // Helper to construct the API endpoint URL
// const getApiUrl = (path) => {
//   const baseUrl = process.env.REACT_APP_API_BASE_URL;
  
//   if (!baseUrl) {
//     console.error("ERROR: REACT_APP_API_BASE_URL is not defined in your .env file.");
//     // Fallback to a common local address or return an empty string to break the URL
//     return `https://192.168.1.36:8000/${path}`; 
//   }
  
//   // Ensure the base URL ends with a slash and the path doesn't start with one
//   const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
//   const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  
//   return `${cleanBaseUrl}${cleanPath}`;
// };

//   try {
//     // Use the preview endpoint for all supported file types
//     const previewLink = getApiUrl(`preview-batch-file?file=${encodeURIComponent(filePath)}`);
//     console.log("Previewlink:", previewLink);

//     if (["doc", "docx", "ppt", "pptx", "xls", "xlsx", "pdf", "txt", "html", "csv"].includes(ext)) {
//       // For Office documents, PDFs and text files, use the preview endpoint
//       setPreviewContent(
//         <iframe
//           src={previewLink}
//           style={{ width: "100%", height: "80vh", border: "none" }}
//           title="File Preview"
//         />
//       );
//     } else if (["jpg", "jpeg", "png", "gif"].includes(ext)) {
//       // For images, use the preview endpoint but display in an img tag
//       setPreviewContent(
//         <div style={{ textAlign: "center" }}>
//           <img
//             src={previewLink}
//             alt="Preview"
//             style={{
//               maxWidth: "100%",
//               maxHeight: "80vh",
//               objectFit: "contain",
//               borderRadius: "4px",
//             }}
//           />
//         </div>
//       );
//     } else {
//       // For unsupported file types, open in a new window
//       const downloadUrl = getApiUrl(filePath);
//       window.open(downloadUrl, "_blank", "noopener,noreferrer");
//       return;
//     }

//     setPreviewModalVisible(true);
//   } catch (error) {
//     toast.error("Preview failed");
//     console.error("Preview error:", error);
//   }
// };
// const handleDocumentChange = (e) => {
//   const files = Array.from(e.target.files);
//   setDocuments(files.map((file) => ({ file })));
// }

//     const handleAddDocument = () => {
//         setDocuments([...documents, { file: null, id: null }]);
//     };

// // Update your handleSubmit function
// const handleSubmit = async (e) => {
//   e.preventDefault();
//   try {
//     const formData = new FormData();
//     formData.append('product_name', product.product_name);
//     formData.append('product_type', product.product_type);
//     formData.append('product_description', product.product_description);
//     formData.append('color', product.color);
    
//     // Handle image for both create and update
//     if (product.img && typeof product.img !== 'string') {
//       formData.append('img', product.img);
//     }
    
//     // Handle document for both create and update
//     documents.forEach((document, index) => {
//                 if (document.file) {
//                     formData.append(`documents[${index}]document`, document.file);
//                 } else if (document.id) {
//                     formData.append(`documents[${index}]id`, document.id);
//                 }
//             });
    
//     if (product.id) {
//       await axios.put(`api/products/${product.id}/?updated_by=${user_id}`, formData);
//       toast.success('Product Successfully Updated.');
//     } else {
//       await axios.post(`api/products/?created_by=${user_id}`, formData);
//       toast.success("Product Successfully Created.");
//     }
    
//     fetchProducts();
//     handleClose();
//   } catch (error) {
//     console.error('Error saving product:', error);
//     toast.error('Error Saving Product');
//   }
// };

//   const handleEdit = (product) => {
//     setProduct(product);
//     handleOpen();
//   };

//   const handleDelete = (id) => {
//     setProductToDelete(id);
//     setConfirmOpen(true);
//   };

//   const confirmDelete = async () => {
//     try {
//       await axios.delete(`api/products/${productToDelete}/?deleted_by=${user_id}`);
//       fetchProducts();
//       toast.success('Product Deleted successfully');
//     } catch (error) {
//       console.error('Error deleting product:', error);
//       toast.error('Error deleting Product');
//     } finally {
//       setProductToDelete(null);
//       setConfirmOpen(false);
//     }
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     setProduct((prev) => ({
//       ...prev,
//       img: file,
//     }));
//   };

//   function getFormattedDate() {
//     const now = new Date();
//     const day = now.toLocaleString('en-US', { weekday: 'short' });
//     const month = now.toLocaleString('en-US', { month: 'short' });
//     const date = now.toLocaleString('en-US', { day: '2-digit' });
//     const year = now.getFullYear();
//     const time = now.toLocaleString('en-US', {
//       hour: '2-digit',
//       minute: '2-digit',
//       hour12: true,
//     });
//     return `${day}, ${month} ${date}, ${year} ${time}`;
//   }

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentDate(getFormattedDate());
//     }, 1000);
//     return () => clearInterval(timer);
//   }, []);

//   console.log(role, "role");


// const handleDocumentsPreview = (prod) => {
//   setSelectedProduct(prod);
//   setSelectedDocuments(prod.documents);
//   setOpenModal(true);
// };

// const handleCloseModal = () => {
//   setOpenModal(false);
// };



// // const handleDocumentOpen = (document) => {
// //   const cleanPath = document.document.startsWith('/') ? document.document.substring(1) : document.document;
// //   const fullUrl = BACKEND_BASE_URL + cleanPath;

// //   if (document.document.endsWith('.pptx')) {
// //     const previewUrl = `https://docs.google.com/gview?url=${encodeURIComponent(fullUrl)}&embedded=true`;
// //     // or use libreoffice online, but it requires more setup and configuration
// //     window.open(previewUrl, '_blank', 'noopener,noreferrer');
// //   } else if (document.document.endsWith('.pdf')) {
// //     window.open(fullUrl, '_blank', 'noopener,noreferrer');
// //   } else {
// //     // Handle other file types
// //   }
// // };

// const handleDocumentOpen = (document) => {
//   handlePreview(document);
// };


//   return (
//     <Box className="page-container">
//       <ToastContainer />
//       <div className="header-container">
//         <Box className="header-icon-container">
//           <CropRotateIcon style={{ color: '#fb7102', fontSize: '28px' }} />
//           <span className="Title">Products</span>
//         </Box>
//         <span className="date-display">{currentDate}</span>
//       </div>

//       <Box className="content-container">
//         <Box className="right-column">

//           <Box className="button-container" >

//             <button className="button_style" onClick={() => {
//               if (rolePermissions?.is_add) {
//                 handleOpen();
//               } else {
//                 toast.error("You don't have permission to add product.");
//               }
//             }}
//             >
//               <AddIcon style={{ verticalAlign: 'middle', marginRight: 6, fontSize: 25 }} />
//               Add Product
//             </button>

//           </Box>


//           <Box className="card-grid">
//  {products.map((prod) => (
//       <Card
//         key={prod.id}
//         className="card"
//         style={{ background: prod.color || '#f5f5f5' }}
//       >
//         <img
//           src={
//             prod.img.startsWith('/media')
//               ? `${process.env.REACT_APP_BACKEND_URL || 'api'}${prod.img}`
//               : prod.img
//           }
//           alt={prod.product_name}
//         />
//         <p className="service_name">{prod.product_name}</p>

//         <CardActions className="card-actions">
//           {/* --- DOCUMENTS PREVIEW ICON --- */}
//           {prod.documents && prod.documents.length > 0 && (
//             <IconButton
//               aria-label="preview documents"
//               size="small"
//               onClick={() => handleDocumentsPreview(prod)}
//               title="Preview Documents" 
//             >
//               <DescriptionIcon fontSize="small" style={{ color: '#1976d2' }} />
//             </IconButton>
//           )}

//           <IconButton
//             aria-label="edit"
//             size="small"
//             onClick={() => {
//               if (rolePermissions?.is_update) {
//                 handleEdit(prod);
//               } else {
//                 toast.error("You don't have permission to Edit product.");
//               }
//             }}
//           >
//             <BorderColorIcon fontSize="small" style={{ color: '#5569a6' }} />
//           </IconButton>

//           <IconButton
//             aria-label="delete"
//             size="small"
//             onClick={() => {
//               if (rolePermissions?.is_delete) {
//                 handleDelete(prod.id);
//               } else {
//                 toast.error("You don't have permission to Delete product.");
//               }
//             }}
//           >
//             <DeleteIcon fontSize="small" style={{ color: '#C53B31' }} />
//           </IconButton>
//         </CardActions>
//       </Card>
//     ))}
// </Box>
//         </Box>
//       </Box>

//       <DrawerComponent
//   open={open}
//   onClose={handleClose}
//   title={product.id ? 'Edit Product' : 'Add New Product'}
// >
//   <form onSubmit={handleSubmit} className="drawer-form">
//     <label htmlFor="custom-file-input" className="file-upload-label">
//       {(product.id && product.img && typeof product.img === 'string') ? (
//         <Card className="card" style={{ background: product.color || '#f5f5f5' }}>
//           <img
//             src={
//               product.img.startsWith('/media')
//                 ? `${process.env.REACT_APP_BACKEND_URL || 'api'}${product.img}`
//                 : product.img
//             }
//             alt={product.product_name}
//           />
//           <Typography variant="body2">{product.img.name || ''}</Typography>
//         </Card>
//       ) : (
//         <Box className="file-upload-container">
//           <input
//             id="custom-file-input"
//             type="file"
//             accept=".jpg,.jpeg,.png"
//             onChange={handleFileChange}
//             style={{ display: 'none' }}
//           />
//           <img src="upload_file.png" alt="Upload" />
//           <Typography variant="body2">
//             {product.img && typeof product.img !== 'string' 
//               ? `Selected image: ${product.img.name}` 
//               : 'No image chosen'
//             }
//           </Typography>
//         </Box>
//       )}
//     </label>

//     {/* Document Upload Field */}
    

//     <LabeledTextField
//       fullWidth
//       label="Product Name"
//       variant="outlined"
//       margin="normal"
//       name="product_name"
//       value={product.product_name}
//       onChange={handleChange}
//       required
//     />
    
//     <LabeledTextField
//       fullWidth
//       label="Product Type"
//       variant="outlined"
//       margin="normal"
//       name="product_type"
//       value={product.product_type}
//       onChange={handleChange}
//       required
//     />
    
//     <LabeledTextField
//       fullWidth
//       label="Product Description"
//       variant="outlined"
//       margin="normal"
//       name="product_description"
//       value={product.product_description}
//       onChange={handleChange}
//       required
//     />
    
//     <Box sx={{ display: 'flex', alignItems: 'center', justifyContent:"space-between", gap: 2, mb: 2,mt: 2 }}>

// <Box>
//   <label htmlFor="document-file-input" className="file-upload-label" style={{ width: '150px' }}>
//     <input
//       id="document-file-input"
//       type="file"
//       multiple
//       accept=".pdf,.doc,.docx,.txt"
//       onChange={handleDocumentChange}
//       style={{ display: 'none' }}
//     />
//     <Button 
//       variant="contained" 
//       component="span" 
//       className="file-uplo-btn upload-button"
//       startIcon={
//         <img 
//           src="upload_file.png" 
//           alt="Upload Document" 
//           style={{ width: '20px', height: '20px' }} 
//         />
//       }
//     >
//       Upload Documents
//     </Button>
//   </label>

//   </Box>
//         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent:"space-between" }}>
//       <input
//         id="color-picker"
//         type="color"
//         name="color"
//         value={product.color}
//         onChange={(e) => setProduct((prev) => ({ ...prev, color: e.target.value }))}
//         className="color-picker"
//         required
//       />
//       <Typography component="label" htmlFor="color-picker" className="color-picker-label">
//         Pick a Light Color
//       </Typography>
// </Box>
//   <Box>
//     <Button type="submit" variant="contained" className="submit-button">
//       {product.id ? 'Update' : 'Submit'}
//     </Button>
//   </Box>
// </Box>

// {documents?.length > 0 && documents[0].file !==null && (
//   <Box sx={{ mt: 2 }}>
//     <Typography variant="body1">Selected Documents:</Typography>
//     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//       {documents?.map((document, index) => (
//         <Chip
//           key={index}
//           label={document?.name || document?.file?.name}
//           onDelete={() => {
//             const newDocuments = documents.filter((doc, i) => i !== index);
//             setDocuments(newDocuments);
//           }}
//         />
//       ))}
//     </Box>
//   </Box>
// )}

// {product?.documents && product?.documents.length > 0 && (
//   <Box sx={{ mt: 2 }}>
//     <Typography variant="body1">Uploaded Documents:</Typography>
//     {product?.documents.map((document, index) => (
//       <Box key={index} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//         <Typography variant="body2">
//           {document.document.split('/').pop()}
//         </Typography>
//         <Button
//           variant="contained"
//           size="small"
//           onClick={() => window.open(`${process.env.REACT_APP_BACKEND_URL || 'api'}${document.document}`, '_blank')}
//         >
//           Preview
//         </Button>
//       </Box>
//     ))}
//   </Box>
// )}

//   </form>
// </DrawerComponent>

//       <Modal open={confirmOpen} onClose={() => setConfirmOpen(false)}>
//         <Box className="confirm-modal">
//           <Typography variant="h6" component="h2">
//             Are you sure you want to delete this product? If yes, all related enquiries will also be
//             deleted automatically.
//           </Typography>
//           <Box className="modal-actions">
//             <Button onClick={confirmDelete} className="modal-button">
//               Yes
//             </Button>
//             <Button onClick={() => setConfirmOpen(false)} className="modal-button">
//               No
//             </Button>
//           </Box>
//         </Box>
//       </Modal>


// <Modal open={openModal} onClose={handleCloseModal}>
//   <Box sx={{
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: { xs: '90%', sm: '70%', md: '50%' },
//     maxHeight: '80vh',
//     bgcolor: 'background.paper',
//     borderRadius: 2,
//     boxShadow: 24,
//     overflow: 'hidden'
//   }}>
//     {/* Header */}
//     <Box sx={{
//       bgcolor: '#F08B51',
//       color: 'white',
//       p: 2,
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center'
//     }}>
//     <Typography
//       variant="h6"
//       component="h2"
//       style={{ color: 'white' }}
//     >
//       Documents for {selectedProduct.product_name}
//     </Typography>
//       <IconButton onClick={handleCloseModal} sx={{ color: 'white' }}>
//         <CloseIcon />
//       </IconButton>
//     </Box>

//     {/* Content */}
//     <Box sx={{ p: 3, maxHeight: '60vh', overflow: 'auto' }}>
//       {selectedDocuments.length > 0 ? (
// <List sx={{ p: 0 }}>
//   {selectedDocuments.map((document) => (
//     <Paper key={document.id} sx={{ mb: 1, overflow: 'hidden' }}>
//       <ListItemButton
//         onClick={() => handlePreview(document)}  // Use handlePreview instead of handleDocumentOpen
//         sx={{
//           '&:hover': {
//             bgcolor: 'rgba(0, 0, 0, 0.04)'
//           },
//           py: 1.5
//         }}
//       >
//         <ListItemIcon>
//           <DescriptionIcon color="primary" />
//         </ListItemIcon>
//         <ListItemText
//           primary={document.document.split('/').pop()}
//           primaryTypographyProps={{
//             fontWeight: 500,
//             noWrap: true
//           }}
//         />
//         <ChevronRightIcon color="action" />
//       </ListItemButton>
//     </Paper>
//   ))}
// </List>
//       ) : (
//         <Box sx={{ textAlign: 'center', py: 4 }}>
//           <Typography color="text.secondary">
//             No documents available
//           </Typography>
//         </Box>
//       )}
//     </Box>

//     {/* Footer */}
//     <Box sx={{
//       bgcolor: 'grey.50',
//       p: 2,
//       borderTop: '1px solid',
//       borderColor: 'divider'
//     }}>
//       <Typography variant="caption" color="text.secondary">
//         Click on any document to view
//       </Typography>
//     </Box>
//   </Box>
// </Modal>

// <Modal open={previewModalVisible} onClose={() => setPreviewModalVisible(false)}>
//   <Box sx={{
//     position: 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: '90%',
//     height: '90%',
//     bgcolor: 'background.paper',
//     borderRadius: 2,
//     boxShadow: 24,
//     overflow: 'hidden'
//   }}>
//     <Box sx={{
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       p: 2,
//       borderBottom: '1px solid #eee'
//     }}>
//       <Typography variant="h6">File Preview</Typography>
//       <IconButton onClick={() => setPreviewModalVisible(false)}>
//         <CloseIcon />
//       </IconButton>
//     </Box>
//     <Box sx={{ height: 'calc(100% - 64px)', overflow: 'hidden' }}>
//       {previewContent}
//     </Box>
//   </Box>
// </Modal>
//     </Box>
//   );
// };

// export default ProductManagement;